module.exports = __webpack_public_path__ + "static/img/ubank-large.c68b081.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bank-logos/ubank-large.png
// module id = m4w4
// module chunks = 6